<template>
  <update-personal-goal-modal
    v-model:is-open="isOpen"
  />
  <div class="challenge-page">
    <riseup-header />
    <challenge-ended v-if="hasChallengeEnded" />
    <join-challenge v-else-if="!isInChallenge" />
    <challenge-not-started v-else-if="!hasChallengeStarted" />
    <challenge-dashboard v-else />
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useRouteParams } from '@vueuse/router';
import RiseupHeader from '@riseupil/base-ui/src/components/RiseupHeader.vue';
import { useChallengeStore } from '../../stores/challenge';
import { useRiseupAccountStore } from '../../stores/riseupAccount';
import JoinChallenge from '../JoinChallenge/JoinChallenge.vue';
import ChallengeDashboard from '../ChallengeDashboard/ChallengeDashboard.vue';
import ChallengeEnded from '../ChallengeEnded/ChallengeEnded.vue';
import ChallengeNotStarted from '../ChallengeNotStarted/ChallengeNotStarted.vue';
import UpdatePersonalGoalModal from '../UpdatePersonalGoalModal/UpdatePersonalGoalModal.vue';
import useUpdatePersonalGoalModal from '../../composables/useUpdatePersonalGoalModal';

const riseupAccountStore = useRiseupAccountStore();
const challengeStore = useChallengeStore();
const { isOpen } = useUpdatePersonalGoalModal();

const { hasChallengeStarted, hasChallengeEnded, isInChallenge } = storeToRefs(challengeStore);

const challengeId = useRouteParams<string>('challengeId');

await challengeStore.init(challengeId.value as string);
await riseupAccountStore.init();

</script>

<style lang="scss" scoped>

.challenge-page {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

</style>
